import { render, staticRenderFns } from "./Monitoring.vue?vue&type=template&id=bfbe9150&scoped=true&lang=pug&"
import script from "./Monitoring.vue?vue&type=script&lang=js&"
export * from "./Monitoring.vue?vue&type=script&lang=js&"
import style0 from "./Monitoring.vue?vue&type=style&index=0&id=bfbe9150&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbe9150",
  null
  
)

export default component.exports